import React from 'react';
import { Field } from 'react-final-form';
import { Input } from '@eika/input';
import { ExpandableRadioButtons } from '@eika/radio-button';
import { composeValidators, minLengthValidator, requiredField } from '../../util/validator';
import ErrorMessage from '../error-message';
// field names for external references
export const confirmBeneficialOwnersName = 'confirmBeneficialOwnerSelect';
export const rejectBeneficialOwnersCommentName = 'confirmBeneficialOwnerRejectComment';
const getError = meta => {
  if (meta.touched && meta.error && typeof meta.error === 'string') {
    return /*#__PURE__*/React.createElement("div", {
      className: "medium-margin-top"
    }, /*#__PURE__*/React.createElement(ErrorMessage, {
      text: meta.error
    }));
  }
  return '';
};
export const confirmedOwnersOption = {
  value: 'Jeg bekrefter at informasjonen over er korrekt'
};
const rejectedOwnersOption = {
  value: 'Informasjonen over er ikke korrekt',
  expandContent: /*#__PURE__*/React.createElement(Field, {
    name: rejectBeneficialOwnersCommentName,
    validate: composeValidators(requiredField, minLengthValidator),
    render: _ref => {
      let {
        input,
        meta
      } = _ref;
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Input, {
        name: "comment",
        label: "Beskriv hva som ikke stemmer",
        value: input.value,
        onChange: input.onChange
      }), getError(meta));
    }
  })
};
const options = [confirmedOwnersOption, rejectedOwnersOption];
export const ConfirmBeneficialOwners = () => {
  const validate = value => {
    if (!value) return 'Du må velge et av alternativene';
    return '';
  };
  return /*#__PURE__*/React.createElement(Field, {
    name: confirmBeneficialOwnersName,
    validate: validate,
    render: _ref2 => {
      let {
        input,
        meta
      } = _ref2;
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ExpandableRadioButtons, {
        options: options,
        selectedOption: input.value,
        onChange: input.onChange,
        className: "margin-top-large"
      }), getError(meta));
    }
  });
};